// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"5258ae09","980":"c20c5e5b","3592":"5258ae09","4401":"5258ae09","5098":"5258ae09"}[chunkId] + ".chunk.css";
};